import React from "react";
import { ActionButton } from "../ActionButton";

interface FormActionsProps {
  onCancel: () => void;
  onSubmit: () => void;
  loading?: boolean;
  submitText?: string;
  cancelText?: string;
  submitIcon?: string;
  isEditing?: boolean;
  submitVariant?: "primary" | "secondary" | "danger";
  submitType?: "button" | "submit";
}

export const FormActions: React.FC<FormActionsProps> = ({
  onCancel,
  onSubmit,
  loading = false,
  submitText,
  cancelText = "Cancelar",
  submitIcon,
  isEditing = false,
  submitVariant = "primary",
  submitType = "button",
}) => {
  const defaultSubmitText = isEditing ? "Atualizar" : "Criar";
  const defaultSubmitIcon = isEditing ? "📝" : "+";

  return (
    <div className="flex flex-col sm:flex-row gap-4 justify-end pt-4 border-t border-gray-200">
      <ActionButton
        variant="outline"
        size="sm"
        onClick={onCancel}
        disabled={loading}
        className="bg-white border-2 border-gray-300 hover:border-gray-400 text-gray-700 hover:text-gray-900"
      >
        {cancelText}
      </ActionButton>

      <ActionButton
        variant={submitVariant}
        size="sm"
        onClick={submitType === "button" ? onSubmit : undefined}
        type={submitType}
        disabled={loading}
        loading={loading}
        icon={submitIcon || defaultSubmitIcon}
      >
        {submitText || defaultSubmitText}
      </ActionButton>
    </div>
  );
};
